import { ReactNode } from "react";
import { PrinterOutlined } from "@ant-design/icons";
import { Button, ButtonColorType, ButtonSize } from "@/ui-components/commonComponents/Button/Button";
import styles from "./style.module.css";

interface ISectionHeaderProps {
  title: string;
  // Optional extra controls rendered alongside PRINT (e.g. the Develop language control). Hidden on
  // print with the rest of the actions.
  actions?: ReactNode;
  // Opt out of the PRINT action (e.g. the Develop empty state, where there's nothing to print).
  hidePrint?: boolean;
  // Awaited before window.print() so a section can warm what the synchronous print render needs first
  // (e.g. Develop preloading its locale bundle).
  onBeforePrint?: () => void | Promise<void>;
}

export default function SectionHeader({ title, actions, hidePrint = false, onBeforePrint }: ISectionHeaderProps) {
  async function handlePrint() {
    // A failed preload (e.g. a locale bundle that won't load) must not suppress printing.
    try {
      await onBeforePrint?.();
    } catch {
      // Fall through and print with whatever is already loaded.
    }
    window.print();
  }

  return (
    <div className={styles.sectionHeader}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.actions}>
        {!hidePrint && (
          <Button
            icon={<PrinterOutlined />}
            buttonSize={ButtonSize.small}
            colorType={ButtonColorType.transparentDark}
            onClick={handlePrint}
          >
            PRINT
          </Button>
        )}
        {actions}
      </div>
    </div>
  );
}
